import React,{useEffect, useState,useMemo} from 'react'
import Header from '../components/header/boardHeader'
import { Oval } from "react-loader-spinner";
import AddCandidate from '../components/addCandidates/addCandidate';
import Avatars from '../components/addCandidates/avatarsList';
import { timezonesList } from "../asstes/timezones";
import { skillsLists } from "../asstes/skills";
import { industriesList } from "../asstes/industries";
import { countriesList } from "../asstes/countries";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import SearchIcon from "@mui/icons-material/Search";
import {ListSubheader,InputAdornment, Input } from "@mui/material";
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import { nanoid } from "nanoid";
import { useNavigate } from "react-router-dom";
import { Buffer } from "buffer";
import { makeStyles } from "@material-ui/core/styles";
import Rating from '@mui/material/Rating';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Tooltip,{ TooltipProps }  from '@mui/material/Tooltip';
import Modal from "@mui/material/Modal";
import SaveToDraftModal from '../components/loginModal/saveToDraftModal';

// Import supabase configuration
import supabase from "../config/supabase";

const containsText = (value, searchText, check) => {
    if(check === 'timezone'){
        if(value.text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1){
            return true;
        } else if(value.value?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1) {
            return true;
        } else {
            return false;
        }
    } else if(check === 'states'){
        if(value?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1){
            return true;
        } else {
            return false;
        }
    } else if(check === 'countries'){
        if(value.country?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1){
            return true;
        } else {
            return false;
        }
    } else if(check === 'industry'){
        if(value.value?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1){
            return true;
        } else {
            return false;
        }
    } else if(check === 'skills'){
        if(value.value?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1){
            return true;
        } else {
            return false;
        }
    }
}

const labels = {
    1: 'Novice',
    2: 'Beginner',
    3: 'Intermediate',
    4: 'Intermediate',
    5: 'Expert',
  };

const color = {
    1: 'text-[#DE3151]',
    2: 'text-[#DE3151]',
    3: 'text-[#FFC805]',
    4: 'text-[#FFC805]',
    5: 'text-[#0DC650]',
  };

  function getLabelText(value) {
    return `${value} Star${value !== 0 ? 's' : ''}, ${labels[value]}`;
  }


function AddCandidates() {
    
    const filter = createFilterOptions();
    const navigate = useNavigate();
    
    const [skillLevelValue, setSkillLevelValue] = useState(1);
    const [SkillLevelhover, setSkillLevelHover] = useState(-1);
    const [showLoader, setShowLoader] = useState(false);
    const [showAvatars, setShowAvatars] = useState(false);
    const [miniScreen, setMiniScreen] = useState(false);
    const [error,setError] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [searchTextForStates, setSearchTextForStates] = useState("");
    const [searchTextForCountries, setSearchTextForCountries] = useState("");
    const [searchTextForIndustry, setSearchTextForIndustry] = useState("");
    const [searchTextForSkills, setSearchTextForSkills] = useState("");
    const [skillList,setSkillList] = useState([]);
    const [skillWithExpList,setSkillWithExpList] = useState([]);
    const [selectedIndustries,setSelectedIndustries] = useState([]);
    const [availability, setAvailability] = useState([
        { id: "1", val: "Immediate" },
        { id: "2", val: "Within 1 week" },
        { id: "3", val: "Within 2 weeks" },
        { id: "4", val: "Within 1 month" },
        { id: "5", val: "Within 2 months" },
        { id: "6", val: "After 2 month" },
    ]);
    const [CV, setCV] = useState("");
    const [avatarSelected, setAvatarSelected] = useState('');
    const [avatarsList, setAvatarsList] = useState([]);
    const [displaySkillsOptions, setDisplaySkillsOptions] = useState([]);
    const [displayIndustryOptions, setDisplayIndustryOptions] = useState([]);
    const [allGaperIds, setAllGaperIds] = useState([]);
    const [values, setValues] = useState([{id: 0, fullName: '', error: false},{ id: 1, gaperId: '', error: false},{id: 2, email: '', error: false},{id: 3, contractStatus: '', error: false},{id: 4, experienceInYears: '', error: false},{id: 5, hourlyRate: '', error: false},{id: 6, industry: '', error: false},{id: 7, SelectedCountry: '', error: false}, {id: 8, SelectedState: '', error: false},{id: 9, timeZone: '', error: false},{id: 10, overlappingHours: '', error: false},{id: 11, availabilityValue: '', error: false},{id: 12, languageProficiency: '', error: false},{id: 13, skill: '', error: false}, {id: 14, skillExp: '', error: false},{id: 15, currentJobTitle: '', error: false},{id: 16, cvFile: '', error: false }])
    const [openModal, setOpenModal] = useState(false);
    const handleOpenModal = () => {
        const isDraftAvailable = localStorage.getItem('isDataAvailbleForDraft');
        if(isDraftAvailable){
            setOpenModal(true);
            localStorage.setItem('isModalOpen', true);
        } else {
            handleNavigate();
        }
    };
    const handleCloseModal = () => {
        localStorage.removeItem('isModalOpen');
        setOpenModal(false);
    }

    const ToBeStyledTooltip = ({ className, ...props }) => (
        <Tooltip {...props} classes={{ tooltip: className }} />
    );
    
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '40%',
        borderRadius: "5px",
        padding: "20px",
        '@media (max-width: 800px)': {
          width: '90%',
          padding: '10px'
        },
        '@media (max-width: 500px)': {
          width: '97%',
          padding: '10px'
        },
    };
    
    const StyledTooltip = styled(ToBeStyledTooltip)(({ theme }) => ({
    backgroundColor: '#ffffff',
    color: '#393939',
    maxWidth: 220,
    fontSize: 16,
    border: '1px solid #666666',
    borderRadius: '4px',
    fontWeight:400,
    fontFamily:"Poppins",
    }));

    const StyledRating = styled(Rating)({
        '& .MuiRating-iconFilled': {
            borderRadius: '2px', 
            marginLeft: '2px',
            backgroundColor: `${skillLevelValue <= 2 ? '#DE3151' : skillLevelValue <= 4 ? '#FFC805' : '#0DC650'}`,
        },
        '& .MuiRating-iconHover': {
            marginLeft: '2px',
            backgroundColor: `${SkillLevelhover <= 2 ? '#DE3151' : SkillLevelhover <= 4 ? '#FFC805' : '#0DC650'}`,
        },
      });

    const availableState = countriesList.find((c) => c.country === values[7].SelectedCountry);

    const reportWindowSize = (e) => {
        var screenSize = window.screen.availWidth;
        if(screenSize < 780) {
            setMiniScreen(true);
        } else {
            setMiniScreen(false);
        }
      }

    useEffect(() => {
        const unloadCallback = (event) => {
            event.preventDefault();
            event.returnValue = "";
            return "";
        };
        
        // window.addEventListener("beforeunload", unloadCallback);
        return () => {
            const isModalOpen = localStorage.getItem('isModalOpen');
            const isDraftAvailable = localStorage.getItem('isDataAvailbleForDraft');
            if(isModalOpen != 'true' && isDraftAvailable == 'true'){
                window.addEventListener("popstate", confirmation());
            } else {
                localStorage.removeItem('isModalOpen');
                localStorage.removeItem('isDataAvailbleForDraft');
            }
            // window.removeEventListener("beforeunload", unloadCallback);
        }
    }, []);

    useEffect( async() => {
        window.addEventListener('resize', (e) => reportWindowSize(e));

        // const { data, error } = await supabase
        // .from('avatars')
        // .select('*')

        // if(data && data.length){
        //     var avatars = [...data];
        //     avatars = data.map( (d) => {
        //         var newAvatarObject = {...d}
        //         newAvatarObject.color = getRandomColor();
        //         return newAvatarObject
        //     })
        //     setAvatarsList(avatars);
        // }
        const { data, error } = await supabase
            .from('avatars')
            .select('*')
            .eq('isAssigned', 'false')
        
        if (data && data.length) {
            var avatars = [...data];
            avatars = data.map((d) => {
            var newAvatarObject = { ...d }
            newAvatarObject.color = getRandomColor();
            return newAvatarObject
            })
            setAvatarsList(avatars)
        }

        const allProfiles = await supabase
        .from('all_profiles')
        .select('serial_no')
        if(allProfiles.data && allProfiles.data.length > 0) {
            setAllGaperIds(allProfiles.data);
        }
    }, []);

    const saveToDraftFunc = async () => {
        setShowLoader(true);
        if(values[1].gaperId.length > 0){
            var candidates = JSON.parse(localStorage.getItem("candidates")) || [];
            var candidateDetails = {};
            candidateDetails['Name'] = values[0].fullName;
            candidateDetails['Gaper Id'] = values[1].gaperId;
            candidateDetails['Exp'] = values[4].experienceInYears.toString();
            candidateDetails['Location'] = values[7].SelectedCountry;
            candidateDetails['Internal Rate'] = values[5].hourlyRate.toString().length > 0 ? values[5].hourlyRate.toString() + ' USD/Hour' : "";
            candidateDetails['Time zone'] = values[9].timeZone;
            candidateDetails['Title'] = values[15].currentJobTitle;
            candidateDetails['Email'] = values[2].email;
            candidateDetails['Contract status'] = values[3].contractStatus;
            candidateDetails['Industry'] = values[6].industry;
            candidateDetails['State'] = values[8].SelectedState;
            candidateDetails['Availability'] = values[11].availabilityValue;
            candidateDetails['Overlapping hours'] = values[10].overlappingHours;
            candidateDetails['Language proficiency'] = values[12].languageProficiency;
            if(values[16].cvFile){
                let id = nanoid().substring(0, 11);
                let extension = "pdf";
                let randomName = id + "." + extension;
        
                var res = await supabase.storage.from('data').upload(`cvs/${randomName}`, values[16].cvFile);
        
                // Get file link
                var cv = res.data ? res.data.Key.substring(res.data.Key.indexOf("/") + 1) : "";
                
                const { signedURL, error } = await supabase
                .storage
                .from('data')
                .createSignedUrl(cv, 315569260)
        
                candidateDetails['CvLink'] = signedURL;
    
            }
            candidates = [...candidates, candidateDetails];
            console.log(candidates);
            localStorage.setItem("candidates", JSON.stringify(candidates));
            // setShowLoader(false)
        }
    }
    
   async function confirmation (){
        const r = window.confirm('Do you want to save your data to drafts?');
        localStorage.removeItem('isModalOpen');
        localStorage.removeItem('isDataAvailbleForDraft');
        if(r) {
            await saveToDraftFunc();
            return true;
        } else {
            return false
        }
    }
    function getRandomColor() {
        var letters = 'BCDEF'.split('');
        var color = '#';
        for (var i = 0; i < 6; i++ ) {
            color += letters[Math.floor(Math.random() * letters.length)];
        }
        return color;
    }

    const displayTimezoneOptions = useMemo ( () => {
        if(timezonesList.length > 0){
            // this will return array of object which can't be render in select options
            var timezoneOptionsObject = timezonesList.filter((timezone) => containsText(timezone, searchText, 'timezone'));

            // so we are going to just make array of values to pass to select options to render
            var timezoneOptionsArray = timezoneOptionsObject.map( (timezone) => {
                return timezone.text;
            })
            return timezoneOptionsArray;
        }
    }, [searchText]);

    const displayStatesOptions = useMemo ( () => {
        if(availableState?.states.length > 0){
            var stateOptions = availableState.states.filter((object) => containsText(object, searchTextForStates, 'states'));

            return stateOptions;
        }
    }, [searchTextForStates, availableState]);

    const displayCountriesOptions = useMemo ( () => {
        if(countriesList?.length > 0){
            var countryOptionsObject = countriesList.filter((object) => containsText(object, searchTextForCountries, 'countries'));
            return countryOptionsObject;
        }
    }, [searchTextForCountries]);

    useMemo ( () => {
        if(industriesList?.length > 0){
            var indusrtyOptionsObject = industriesList.filter((object) => containsText(object, searchTextForIndustry, 'industry'));
            setDisplayIndustryOptions(indusrtyOptionsObject);
        }
    }, [searchTextForIndustry]);

    useMemo ( () => {
        if(displaySkillsOptions?.length > 0){
            var skillsOptionsObject = displaySkillsOptions.filter((object) => containsText(object, searchTextForSkills, 'skills'));
            setDisplaySkillsOptions(skillsOptionsObject);
        }
        else if(skillsLists?.length > 0){
            var skillsOptionsObject = skillsLists.filter((object) => containsText(object, searchTextForSkills, 'skills'));
            setDisplaySkillsOptions(skillsOptionsObject);
        }
    }, [searchTextForSkills]);

    const handleSubmit = async(e) =>{
        e.preventDefault();
        localStorage.setItem('isDataAvailbleForDraft', false);
        if(avatarSelected === '') {
            setError(true);
        } else {
            setShowLoader(true);
            var availability = checkAvailabilityInDays();
            var skillLevel = CheckSkillExperience();
            var skillsWithLevels = [];
    
            if(skillList?.length > 0) {
                skillsWithLevels = skillList;
            } else {
                skillsWithLevels.push({
                    "skill": values[13].skill,
                    "level": skillLevelValue
                })
            }
            var industries = [...selectedIndustries]
            if(selectedIndustries?.length <= 0) {
                industries.push(values[6].industry)
            }
    
            let id = nanoid().substring(0, 11);
            let extension = "pdf";
            let randomName = id + "." + extension;
    
            var res = await supabase.storage.from('data').upload(`cvs/${randomName}`, values[16].cvFile);
    
            // Get file link
            var cv = res.data ? res.data.Key.substring(res.data.Key.indexOf("/") + 1) : "";
            
            const { signedURL, error } = await supabase
            .storage
            .from('data')
            .createSignedUrl(cv, 315569260)
    
            if(signedURL){
                const { data, error } = await supabase
                .from('all_profiles')
                .insert({ full_name: values[0].fullName, serial_no: values[1].gaperId, email: values[2].email, current_job_title: values[15].currentJobTitle, exp: values[4].experienceInYears, contract_status: values[3].contractStatus, location: values[7].SelectedCountry, states: values[8].SelectedState, timezone: values[9].timeZone, expected_hourly_rate: values[5].hourlyRate, availability: availability, overlapping_hours: values[10].overlappingHours, language_proficiency: values[12].languageProficiency, skill_level: skillsWithLevels, industries: industries.toString(), cv_link: signedURL, emoji_url: avatarSelected.url,cv_name:randomName });
                
                if(data && data.length > 0) {
                    const memojiUpdateResponse = await supabase
                    .from('avatars')
                    .update({ isAssigned: 'true' })
                    .match({ id: avatarSelected.id })
                    localStorage.setItem('Candidate', JSON.stringify(data[0]))
                    navigate(`/candidateAdded`)
                }
            }
        }
    }
    
    const checkAvailabilityInDays = () => {
        if(values[11].availabilityValue === "Immediate") {
            return 0;
        } else if(values[11].availabilityValue === "Within 1 week"){
            return 7;
        } else if(values[11].availabilityValue === "Within 2 weeks"){
            return 14;
        } else if(values[11].availabilityValue === "Within 1 month"){
            return 30;
        } else if(values[11].availabilityValue === "Within 2 months"){
            return 60;
        } else if(values[11].availabilityValue === "After 2 month"){
            return 65;
        }
    }

    const CheckSkillExperience = () => {
        if(values[14].skillExp <= 5){
            return values[14].skillExp;
        } else {
            return 5;
        }
    }

    const handleSkillAdd = () =>{ 
        if(values[13].skill !== '' && values[14].skillExp !== ''){
            var skillLevel = CheckSkillExperience();
            var isAlreadyExist = false
            skillWithExpList.forEach((el, i) => {
                if(el.skill === values[13].skill){
                    isAlreadyExist = true
                }
            })
            if(isAlreadyExist){
                var updateSkillList = [...skillList];
                var updateSkillWithExpList = [...skillWithExpList];
                updateSkillList = updateSkillList.map((el) => {
                    if(el.skill === values[13].skill){
                        var updatedValue = {...el};
                        updatedValue.skill = values[13].skill;
                        updatedValue.level = skillLevelValue ;
                        return updatedValue;
                    } else {
                        return el
                    }
                })
                updateSkillWithExpList = updateSkillWithExpList.map((el) => {
                    if(el.skill === values[13].skill){
                        var updatedValue = {...el};
                        updatedValue.skill = values[13].skill
                        updatedValue.year = values[14].skillExp;
                        updatedValue.level = skillLevelValue;
                        return updatedValue;
                    } else {
                        return el
                    }
                })
                setSkillList(updateSkillList);
                setSkillWithExpList(updateSkillWithExpList);
            } else{
                var skillOptions = displaySkillsOptions.filter((object) => {
                    if(object.value !== values[13].skill){
                        return object;
                    }
                });
                setDisplaySkillsOptions(skillOptions);
                setSkillList([...skillList,{"skill": values[13].skill,"level": skillLevelValue}])
                setSkillWithExpList([...skillWithExpList,{"skill": values[13].skill,"year": values[14].skillExp,"level": skillLevelValue}]);
            }
            setSkillLevelValue(1);
            var newState = [...values];
            newState[13].skill = '';
            newState[14].skillExp = '';
            setValues(newState);
        } else {
            if(values[13].skill === '' && values[14].skillExp === '') {
                setValues((prev) => {
                    var newstate = [...prev];
                    newstate[13].error = true;
                    newstate[14].error = true;
                    return newstate;
                });
            } else {
                if(values[13].skill === '') {
                    setValues((prev) => {
                        var newstate = [...prev];
                        newstate[13].error = true;
                        return newstate;
                    });
                } else {
                    setValues((prev) => {
                        var newstate = [...prev];
                        newstate[14].error = true;
                        return newstate;
                    });
                }
            }
        }
    }

    const handleIndustryAdd = () =>{ 
        if(values[6].industry !== ''){
            var isAlreadyExist = false
            displayIndustryOptions.forEach((el, i) => {
                if(el === values[6].industry){
                    isAlreadyExist = true
                }
            })
            if(isAlreadyExist){
                setValues((prev) => {
                    var newstate = [...prev];
                    newstate[6].error = true;
                    return newstate;
                });
            } else {
                var industryOptions = displayIndustryOptions.filter((object) => {
                    if(object.value !== values[6].industry){
                        return object;
                    }
                });
                setDisplayIndustryOptions(industryOptions);
                setSelectedIndustries([...selectedIndustries,values[6].industry])
            }
            var newState = [...values];
            newState[6].industry = '';
            setValues(newState);
            setError(false);
        } else {
            setValues((prev) => {
                var newstate = [...prev];
                newstate[6].error = true;
                return newstate;
            });
        }
    }

    const handleFileUpload = async(e) => {
        console.log(e.target.files[0]);
        const maxfileSize = 1024 * 1024;
        const fileSize = e.target.files[0].size;
        if(fileSize > maxfileSize){
            var newState = [...values];
            newState[16].error = true;
            setValues(newState);
        } else {
            var newState = [...values];
            newState[16].cvFile = e.target.files[0];
            newState[16].error = false;
            setValues(newState);
            setError(false)
        }
    }

    const handleChooseAvatar = (url) => {
        console.log(url)
        setAvatarSelected(url);
        setError(false);
    }

    const handleNextClick = () => {
        // check if any error exist or not
        var flag = false;
        values.forEach( (obj, index) => {
            if(obj[Object.keys(obj)[1]] === '' && Object.keys(obj)[1] !== 'email'){
                if(Object.keys(obj)[1] === 'skill' || Object.keys(obj)[1] === 'skillExp'){
                    if(skillList.length <= 0){
                        setValues((prev) => {
                            var newstate = [...prev];
                            newstate[index].error = true;
                            return newstate;
                        });
                        setError(true);
                        flag = true;
                    }
                } else if(Object.keys(obj)[1] === 'industry'){
                    if(selectedIndustries.length <= 0){
                        setValues((prev) => {
                            var newstate = [...prev];
                            newstate[index].error = true;
                            return newstate;
                        });
                        setError(true);
                        flag = true;
                    }
                }
                else {
                    setValues((prev) => {
                        var newstate = [...prev];
                        newstate[index].error = true;
                        return newstate;
                    });
                    setError(true);
                    flag = true;
                }
            } else if (Object.keys(obj)[1] === 'experienceInYears') {
                if(obj.experienceInYears > 20){
                    setValues((prev) => {
                        var newstate = [...prev];
                        newstate[index].error = true;
                        return newstate;
                    });
                    setError(true);
                    flag = true;
                }
            } else if (Object.keys(obj)[1] === 'email' && obj[Object.keys(obj)[1]].length > 0) {
                if(!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(obj.email)){
                    setValues((prev) => {
                        var newstate = [...prev];
                        newstate[2].error = true;
                        return newstate;
                    });
                    setError(true);
                    flag = true;
                }
            } else if(values[index].error || values[index].exist){
                    setError(true);
                    flag = true;
            }
        })
        if(!flag){
            setShowAvatars(true);
            setError(false);
        }
    }

    // removing a skill from a skillList
    const removeSkill = (skill) => {
        var afterRemove = skillList.filter((value) => value.skill !== skill);
        var afterRemovefromskillWithExp = skillWithExpList.filter((value) => value.skill !== skill);
        setSkillList(afterRemove);
        setSkillWithExpList(afterRemovefromskillWithExp);
        var isAlreadyExist = false
        displaySkillsOptions.forEach((el, i) => {
            if(el.value === skill){
                isAlreadyExist = true
            }
        })
        if(!isAlreadyExist){
            var skillOptions = [...displaySkillsOptions, {value: skill}]
            setDisplaySkillsOptions(skillOptions)
        }
    }

    const editSkill = (skillObject) => {
        var isAlreadyExist = false
        displaySkillsOptions.forEach((el, i) => {
            if(el.value === skillObject.skill){
                isAlreadyExist = true
            }
        })
        if(!isAlreadyExist){
            var skillOptions = [...displaySkillsOptions, {value: skillObject.skill}]
            setDisplaySkillsOptions(skillOptions)
        }
        setSkillLevelValue(skillObject.level);
        setSkillLevelHover(-1);
        var newstate = [...values];
        newstate[14].skillExp = skillObject.year;
        newstate[13].skill = skillObject.skill;
        newstate[14].error = false;
        newstate[13].error = false;
        setValues(newstate);
    }

    // removing a industry from a industryList
    const removeIndustry = (industry) => {
        var afterRemove = selectedIndustries.filter((value) => value !== industry);
        setSelectedIndustries(afterRemove);
        var isAlreadyExist = false
        displayIndustryOptions.forEach((el, i) => {
            if(el === industry){
                isAlreadyExist = true
            }
        })
        if(!isAlreadyExist){
            var industryOptions = [...displayIndustryOptions, industry]
            setDisplayIndustryOptions(industryOptions);
        }
    }

    const editIndustry = (industry) => {
        var isAlreadyExist = false
        displayIndustryOptions.forEach((el, i) => {
            if(el === industry){
                isAlreadyExist = true
            }
        })
        if(!isAlreadyExist){
            var industryOptions = [...displayIndustryOptions, industry]
            setDisplayIndustryOptions(industryOptions);
        }
        var newstate = [...values];
        newstate[6].industry = industry;
        newstate[6].error = false;
        setValues(newstate);
    }

    const handleChange = (index,key) => (event) => {
        localStorage.setItem('isDataAvailbleForDraft', true);
        var newstate = [...values];
        if(key === 'hourlyRate') {
            newstate[index][key] = parseInt(event.target.value) || '';
            newstate[index].error = false;
            setValues(newstate);
            setError(false)
        } else if(key === 'SelectedCountry') {
            newstate[index][key] = event.target.value;
            newstate[index].error = false;
            newstate[index+1].SelectedState = '';
            setValues(newstate);
            setError(false)
        } else {
            newstate[index][key] = event.target.value;
            newstate[index].error = false;
            setValues(newstate);
            setError(false)
        }
    };

    const handleOnBlurEvent = (index,key) => {
        var newstate = [...values];
        if(key === 'experienceInYears' && newstate[index][key]){
            if(newstate[index][key] > 20){
                newstate[index][key] = 20;
                newstate[index].error = false;
                setValues(newstate);
            } else if(newstate[index][key] < 0){
                newstate[index][key] = 0;
                newstate[index].error = false;
                setValues(newstate);
            }
        } else if(key === 'hourlyRate' && newstate[index][key]){
            if(newstate[index][key] > 1000) {
                newstate[index][key] = 1000;
                newstate[index].error = false;
                setValues(newstate);
            } else if(newstate[index][key] < 0){
                newstate[index][key] = 0;
                newstate[index].error = false;
                setValues(newstate);
            }
        } else if(key === 'gaperId' && newstate[index][key]){
            if(newstate[index][key] < 0){
                newstate[index][key] = 0;
                newstate[index].error = false;
            }
            var checkIfExist = allGaperIds.findIndex((elem) => newstate[index][key] == elem.serial_no);
            if(checkIfExist !== -1) {
                newstate[index].exist = true;
            } else {
                newstate[index].exist = false;
            }
            setValues(newstate);
        }
    }

    const usePlaceholderStyles = makeStyles(theme => ({
        placeholder: {
          color: "#aaa"
        }
      }));
      const Placeholder = ({ children }) => {
        const classes = usePlaceholderStyles();
        return <div className={classes.placeholder}>{children}</div>;
      };

      const handleNavigate = (param) => {
        if(param === 'save'){
             saveToDraftFunc();
            navigate('/addProspect');
            localStorage.removeItem('isModalOpen');
            localStorage.removeItem('isDataAvailbleForDraft');
        } else {
            navigate('/addProspect');
            localStorage.removeItem('isModalOpen');
            localStorage.removeItem('isDataAvailbleForDraft');
        }
    }

  return (
    <div className="w-full h-full">
        <div className="sticky top-0 z-50">
            <Header addCandidate={true} />
        </div>
        <Modal
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            BackdropProps={{style: {backgroundColor: '#F8FDFFB2'}}}
        >
          <>
          <Header addCandidate={true} />
            <Box sx={modalStyle}>
                <SaveToDraftModal miniScreen={miniScreen} handleCloseModal={handleCloseModal} handleNavigate={handleNavigate} />
            </Box>
          </>
        </Modal>
        {showLoader && (
          <div className="fixed flex items-center justify-center z-10 w-full h-full top-0 bg-white-1">
            {/* Add backdrop */}
            
            <div className={`relative flex`}>
              <Oval
                  color="white"
                  secondaryColor="grey"
                  height="40"
                  width="60"
                />
                <div className="flex items-center">Hold Tight-just getting this page ready.</div>
            </div>
          </div>
        )}  
        <div className='h-full w-full bg-blue-7 xl:pl-56 xl:pr-56 xl:pb-24 xl:pt-16 px-3 py-10'>
            <form onSubmit={handleSubmit}>
                <div className={`${showAvatars && 'hidden'} w-auto h-auto bg-white-1 rounded-md md:pl-20 md:pr-20 md:pt-8 md:pb-10 p-5`}>
                    <div className='mb-6'>
                        <StyledTooltip title="Back">
                            <div className='flex justify-center items-center h-11 w-11 bg-blue-1 rounded-full p-3 cursor-pointer' onClick={handleOpenModal}>
                                <img src="./backButton.svg" alt="" />
                            </div>
                        </StyledTooltip>
                    </div>
                    <div className="bg-blue-7 w-fit p-2 rounded md:hidden mb-2">
                        <span className='md:font-semibold text-blue-1'>Step 1 of 2</span>
                    </div>
                    <div className='flex justify-between items-center'>
                        <h1 className="text-2xl font-bold">Add a new candidate</h1>
                        <div className="bg-blue-7 p-2 rounded omd-1:hidden">
                            <span className='md:font-semibold text-blue-1'>Step 1 of 2</span>
                        </div>
                    </div>
                    {/* Full Name */}
                    <div className="mt-6">
                        <div className="flex justify-between">
                        <label htmlFor="username" className="block mb-2 md:text-base text-sm font-medium text-black-1">Full name <span className='text-red-1'>*</span></label>
                        <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[0].error ? "visible":"invisible"}`}>Fill this field to continue.</p>
                        </div>
                        {/* <input type="text" id="username" className="border-grey-7 font-medium border text-black-1 p-5 placeholder-grey-7 text-sm rounded-sm  block w-full" placeholder="Enter candidates full name" /> */}
                        <TextField error={values[0].error} fullWidth id="username"  placeholder='Enter candidates full name' value={values[0].fullName} onChange={handleChange(0, 'fullName')} variant="outlined" className='text-blue-1 p-5' />
                    </div>
                    {/* Gaper Id */}
                    <div className="mt-6">
                        <div className="flex justify-between">
                        <label htmlFor="gaperId" className="block mb-2 md:text-base text-sm font-medium text-black-1">Gaper Id <span className='text-red-1'>*</span></label>
                        <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[1].error || values[1].exist ? "visible":"invisible"}`}>{values[1].exist ? 'This id is already assigned!': 'Fill this field to continue.'}</p>
                        </div>
                        {/* <input type="text" id="gaperId" className="border-grey-7 font-medium border text-black-1 p-5 placeholder-grey-7 placeholder-font-normal text-sm rounded-sm  block w-full" placeholder="Enter Gaper ID" /> */}
                        <TextField error={values[1].error} fullWidth id="gaperid" type="number" value={values[1].gaperId} placeholder='Enter Gaper ID' onChange={handleChange(1,'gaperId')} variant="outlined" inputProps={{min: 0}} onBlur={() => handleOnBlurEvent(1,'gaperId')} />
                    </div>
                    {/* Email */}
                    <div className="mt-6">
                        <div className="flex justify-between">
                        <label htmlFor="email" className="block mb-2 md:text-base text-sm font-medium text-black-1">Email address</label>
                        <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[2].error ? "visible":"invisible"}`}>The email address is incorrect!</p>
                        </div>
                        <TextField error={values[2].error} fullWidth type="email" id="email" value={values[2].email} onChange={handleChange(2,'email')} placeholder='Enter candidates email address' variant="outlined" />
                        {/* <input type="email" id="email" className="border-grey-7 font-medium border text-black-1 p-5 placeholder-grey-7 text-sm rounded-sm  block w-full" placeholder="Enter candidates email address" /> */}
                    </div>
                    {/* contract status */}
                    <div className="mt-6">
                        <div className="flex justify-between">
                        <label htmlFor="contact" className="block mb-2 md:text-base text-sm font-medium text-black-1">Contract status <span className='text-red-1'>*</span></label>
                        <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[3].error ? "visible":"invisible"}`}>This status needs to be updated!</p>
                        </div>
                        <Select error={values[3].error} value={values[3].contractStatus} onChange={handleChange(3,'contractStatus')}
                         sx={{ width: 2/2 }}
                         displayEmpty
                         renderValue={
                            values[3].contractStatus !== "" ? undefined : () => <Placeholder>Enter contract status</Placeholder>
                          }
                         > 
                            <MenuItem value="Part Time">Part Time</MenuItem>
                            <MenuItem value="Full Time">Full Time</MenuItem>
                            <MenuItem value="Hourly">Hourly</MenuItem>
                        </Select>
                    </div>
                    {/* Experience and Hourly rate */}
                    <div className="mt-6">
                        <div className='md:grid md:grid-cols-12 md:gap-10 xl:gap-14 oxl1:gap-16'>
                            <div className="md:col-span-6">
                                <div className="flex justify-between">
                                <label htmlFor="exp" className="block mb-2 md:text-base text-sm font-medium text-black-1">Experience <span className='text-red-1'>*</span></label>
                                <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[4].error ? "visible":"invisible"}`}>Select years less than 21.</p>
                                </div>
                                <TextField error={values[4].error} fullWidth value={values[4].experienceInYears} onChange={handleChange(4,'experienceInYears')} type="number" id="exp" placeholder='Your exp from 0-20 years' variant="outlined" className='font-medium text-black-1' inputProps={{min: 0, max: 20}} onBlur={() => handleOnBlurEvent(4,'experienceInYears')} />
                            </div>
                            <div className="md:col-span-6 md:mt-0 mt-6">
                                <div className="md:flex md:justify-between">
                                <label htmlFor="hourlyrate" className="block mb-2 md:text-base text-sm font-medium text-black-1">Hourly rate <span className='text-red-1'>*</span></label>
                                <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[5].error ? "visible":"invisible"}`}>Select hours.</p>
                                </div>
                                {/* <input type="Select" id="contact" className="border-grey-7 font-medium border text-black-1 p-5 placeholder-grey-7 text-sm rounded-sm  block w-full" placeholder="Hourly rate" /> */}
                                <TextField error={values[5].error} fullWidth value={values[5].hourlyRate} onChange={handleChange(5,'hourlyRate')} type="number" id="hourlyrate" placeholder='Hourly rate' variant="outlined" className='font-medium text-black-1' onBlur={() => handleOnBlurEvent(5,'hourlyRate')} />
                            </div>
                        </div>
                    </div>
                    {/* Industry */}
                    <div className="mt-6">
                        <div className='md:grid md:grid-cols-12 md:gap-10 xl:gap-14 oxl1:gap-16 gap-2 flex md:justify-center items-center justify-between'>
                            <div className='col-span-10'>
                                <div className="flex justify-between">
                                <label htmlFor="industry" className="block mb-2 md:text-base text-sm font-medium text-black-1">Industry <span className='text-red-1'>*</span></label>
                                <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[6].error ? "visible":"invisible"}`}>Select an industry to continue.</p>
                                </div>
                                <Autocomplete
                                    value={values[6].industry}
                                    onChange={(event, newValue) => {
                                        if (typeof newValue === 'string') {
                                            var newstate = [...values];
                                            newstate[6].industry = newValue;
                                            newstate[6].error = false;
                                            setValues(newstate);
                                        } else if (newValue && newValue.inputValue) {
                                        // Create a new value from the user input
                                            var newstate = [...values];
                                            newstate[6].industry = newValue?.inputValue;
                                            newstate[6].error = false;
                                            setValues(newstate);
                                        } else {
                                            var newstate = [...values];
                                            newstate[6].industry = newValue?.value || '';
                                            newstate[6].error = false;
                                            setValues(newstate);
                                        }
                                    }}
                                    filterOptions={(options, params) => {
                                        const filtered = filter(options, params);
                                
                                        const { inputValue } = params;
                                        // Suggest the creation of a new value
                                        const isExisting = options.some((option) => inputValue === option.value);
                                        if (inputValue !== '' && !isExisting) {
                                        filtered.push({
                                            inputValue,
                                            value: `Add "${inputValue}"`,
                                        });
                                        }
                                
                                        return filtered;
                                    }}
                                    selectOnFocus
                                    clearOnBlur
                                    handleHomeEndKeys
                                    id="industry"
                                    options={displayIndustryOptions}
                                    getOptionLabel={(option) => {
                                        // Value selected with enter, right from the input
                                        if (typeof option === 'string') {
                                        return option;
                                        }
                                        // Add "xxx" option created dynamically
                                        if (option.inputValue) {
                                        return option.inputValue;
                                        }
                                        // Regular option
                                        return option.value;
                                    }}
                                    renderOption={(props, option) => <li {...props}>{option.value}</li>}
                                    sx={{ width: 2/2 }}
                                    freeSolo
                                    includeInputInList
                                    renderInput={(params) => (
                                        <TextField {...params} error={values[6].error} placeholder='Enter related industry' />
                                    )}
                                    />
                            </div>
                            <div className="md:col-span-2 col-span-12 flex justify-end md:justify-start mt-6 hover:cursor-pointer" onClick={handleIndustryAdd}>
                                <img src='/addSkill.svg' />
                            </div>
                        </div>

                        {selectedIndustries.length > 0 && <div className='flex justify-start flex-wrap gap-6 mt-6'>
                            {selectedIndustries.map((industryEl, i) => (
                                <div key={i} className={`bg-[#F1F2F5] py-3 px-5 relative cursor-pointer rounded-[2px] ${values[6].industry ? industryEl === values[6].industry && 'border border-blue-1' : selectedIndustries.length-1 === i && 'border border-blue-1'}`} onClick={() => editIndustry(industryEl)}>
                                    <div className=''>{industryEl}</div>
                                    <div className='bg-[#6B6C7E] w-5 h-5 text-white-1 rounded-full flex justify-center items-center absolute top-0 -right-3 text-xs cursor-pointer' onClick={() => removeIndustry(industryEl)}><span>x</span> </div>
                                </div>
                            ))}
                        </div>}
                    </div>
                    {/* Location and State */}
                    <div className="mt-6">
                        <div className='md:grid md:grid-cols-12 md:gap-10 xl:gap-14 oxl1:gap-16'>
                            <div className="md:col-span-6">
                                <div className="flex justify-between">
                                <label htmlFor="contact" className="block mb-2 md:text-base text-sm font-medium text-black-1">Location <span className='text-red-1'>*</span></label>
                                <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[7].error ? "visible":"invisible"}`}>Select location.</p>
                                </div>
                                
                                <Select
                                error={values[7].error}
                                value={values[7].SelectedCountry}
                                onChange={handleChange(7,'SelectedCountry')}
                                onClose={() => setSearchTextForCountries('')}
                                displayEmpty
                                renderValue={() => {
                                    if(values[7].SelectedCountry !== ""){
                                        return values[7].SelectedCountry
                                    }
                                    else{
                                        return <Placeholder>Select country</Placeholder>
                                    }
                                }}
                                sx={{ width: 2/2 }}
                                > 
                                    <ListSubheader>
                                        <TextField
                                        size="small"
                                        // Autofocus on textfield
                                        autoFocus
                                        placeholder="Search Country"
                                        fullWidth
                                        InputProps={{
                                            endAdornment: (
                                            <InputAdornment position="end">
                                                <SearchIcon />
                                            </InputAdornment>
                                            )
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                        onChange={(e) => setSearchTextForCountries(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key !== "Escape") {
                                            // Prevents autoselecting item while typing (default Select behaviour)
                                            e.stopPropagation();
                                            }
                                        }}
                                        />
                                    </ListSubheader>
                                    {displayCountriesOptions?.length > 0 ?
                                    displayCountriesOptions?.map((value, key) => (
                                        <MenuItem value={value.country} key={key}>
                                            <span className='flex'>
                                                <img
                                                    loading="lazy"
                                                    width="36px"
                                                    height="20px"
                                                    src={`https://flagcdn.com/w20/${value.code}.png`}
                                                    srcSet={`https://flagcdn.com/w40/${value.code}.png`}
                                                    alt={`Flag of us`}
                                                    className="mr-2"
                                                    />
                                                {value.country}
                                                </span>
                                        </MenuItem>
                                        ))
                                    :
                                    <MenuItem disabled>No Result Found</MenuItem>
                                    }
                                </Select>
                                
                            </div>
                            <div className="md:col-span-6 md:mt-0 mt-6">
                                <div className="flex justify-between">
                                <label htmlFor="contact" className="block mb-2 md:text-base text-sm font-medium text-black-1">States <span className='text-red-1'>*</span></label>
                                <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[8].error ? "visible":"invisible"}`}>Select states.</p>
                                </div>
                                <FormControl sx={{ minWidth: 2/2 }} disabled={displayStatesOptions?.length > 0 ? false : true}>
                                    <Select
                                    error={values[8].error}
                                    placeholder="State"
                                    value={values[8].SelectedState}
                                    onChange={handleChange(8,'SelectedState')}
                                    onClose={() => setSearchTextForStates("")}
                                    displayEmpty
                                    renderValue={() => {
                                        if(values[8].SelectedState !== ""){
                                            return values[8].SelectedState
                                        }
                                        else{
                                            return <Placeholder>Select states</Placeholder>
                                        }
                                    }}
                                    >
                                        <ListSubheader>
                                            <TextField
                                            size="small"
                                            // Autofocus on textfield
                                            autoFocus
                                            placeholder="Search States"
                                            fullWidth
                                            InputProps={{
                                                endAdornment: (
                                                <InputAdornment position="end">
                                                    <SearchIcon />
                                                </InputAdornment>
                                                )
                                            }}
                                            onClick={(e) => e.stopPropagation()}
                                            onChange={(e) => setSearchTextForStates(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key !== "Escape") {
                                                // Prevents autoselecting item while typing (default Select behaviour)
                                                e.stopPropagation();
                                                }
                                            }}
                                            />
                                        </ListSubheader>
                                        { displayStatesOptions?.length > 0 ?
                                            displayStatesOptions?.map((e, key) => (
                                            <MenuItem value={e} key={key}>
                                                <span className='flex mr-2'>
                                                    <img src="/state.svg" className="mr-2 h-6 w-6" />
                                                    {e}
                                                </span>
                                            </MenuItem>
                                            ))
                                        :
                                        <MenuItem disabled>No Result Found</MenuItem>
                                        }
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                    </div>
                    {/* avaliability */}
                    <div className="mt-6">
                        <div className="flex justify-between">
                            <label htmlFor="industry" className="block mb-2 md:text-base text-sm font-medium text-black-1">Availability <span className='text-red-1'>*</span></label>
                            <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[11].error ? "visible":"invisible"}`}>Select availability.</p>
                        </div>
                        <Select
                        error={values[11].error}
                        value={values[11].availabilityValue}
                        onChange={handleChange(11,'availabilityValue')}
                        displayEmpty
                        renderValue={
                        values[11].availabilityValue !== "" ? undefined : () => <Placeholder>Select your availability</Placeholder>
                            }
                        sx={{ width: 2/2 }}
                        >
                            {
                                availability.map((ava,index)=>(
                                    <MenuItem value={ava.val} key={index}>{ava.val}</MenuItem>
                                ))
                            }
                        </Select>
                    </div>
                    {/* timezone and overlaping hours */}
                    <div className="mt-6">
                        <div className='md:grid md:grid-cols-12 md:gap-10 xl:gap-14 oxl1:gap-16'>
                            <div className="md:col-span-6">
                                <div className="flex justify-between">
                                    <label htmlFor="contact" className="block mb-2 md:text-base text-sm font-medium text-black-1">Time zone <span className='text-red-1'>*</span></label>
                                    <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[9].error ? "visible":"invisible"}`}>Select time zone.</p>
                                </div>
                                <Select 
                                    error={values[9].error}
                                    value={values[9].timeZone}
                                    onChange={handleChange(9,'timeZone')}
                                    onClose={() => setSearchText("")}
                                    // This prevents rendering empty string in Select's value
                                    // values[9].timeZone
                                    // if search text would exclude currently selected option.
                                    displayEmpty
                                    renderValue={() => {
                                        if(values[9].timeZone !== ""){
                                            return values[9].timeZone
                                        }
                                        else{
                                            return <Placeholder>Select Timezone</Placeholder>
                                        }
                                    }}
                                    sx={{ width: 2/2 }}
                                >
                                    <ListSubheader>
                                        <TextField
                                        size="small"
                                        // Autofocus on textfield
                                        autoFocus
                                        placeholder="Search time zone"
                                        fullWidth
                                        InputProps={{
                                            endAdornment: (
                                            <InputAdornment position="end">
                                                <SearchIcon />
                                            </InputAdornment>
                                            )
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key !== "Escape") {
                                            // Prevents autoselecting item while typing (default Select behaviour)
                                            e.stopPropagation();
                                            }
                                        }}
                                        />
                                    </ListSubheader>
                                    {displayTimezoneOptions?.length > 0 ?
                                        displayTimezoneOptions?.map((timezone, key) => (
                                            <MenuItem value={timezone} key={key}>
                                                <span className='flex'>
                                                    <img src="/state.svg" className="mr-2 h-6 w-6" />
                                                    {timezone}
                                                </span>
                                            </MenuItem>
                                        ))
                                        :
                                        <MenuItem disabled>No Result Found</MenuItem>
                                    }
                                </Select>
                            </div>
                            <div className="md:col-span-6 md:mt-0 mt-6">
                                <div className="flex justify-between">
                                    <label htmlFor="contact" className="block mb-2 md:text-base text-sm font-medium text-black-1">Overlapping hours <span className='text-red-1'>*</span></label>
                                    <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[10].error ? "visible":"invisible"}`}>Select hours.</p>
                                </div>
                                <Select error={values[10].error} value={values[10].overlappingHours} onChange={handleChange(10,'overlappingHours')}
                                displayEmpty
                                renderValue={
                                values[10].overlappingHours !== "" ? undefined : () => <Placeholder>Select hours</Placeholder>
                                 }
                                 sx={{ width: 2/2 }}
                                 > 
                                <MenuItem disabled>Select Hours</MenuItem>
                                    {[...Array(8)].map((x, i) =>
                                        <MenuItem key={i} value={i}>{i} Hour{i>1 && 's'}</MenuItem>
                                    )}
                                </Select>
                            </div>
                        </div>
                    </div>
                    {/* language proficiency */}
                    <div className="mt-6">
                        <div className="flex justify-between">
                            <label htmlFor="industry" className="block mb-2 md:text-base text-sm font-medium text-black-1">Language proficiency <span className='text-red-1'>*</span></label>
                            <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[12].error ? "visible":"invisible"}`}>Select language proficiency.</p>
                        </div>
                        <Select
                        error={values[12].error}
                        value={values[12].languageProficiency}
                        onChange={handleChange(12,'languageProficiency')}
                        displayEmpty
                        renderValue={
                         values[12].languageProficiency !== "" ? undefined : () => <Placeholder>English</Placeholder>
                            }
                         sx={{ width: 2/2 }}
                         >
                                <MenuItem value="1">Basic</MenuItem>
                                <MenuItem value="2">Conversational</MenuItem>
                                <MenuItem value="3">Fluent</MenuItem>
                        </Select>
                    </div>
                    {/* skill with exp */}
                    <div className="mt-6">
                        <form>
                            <div className='md:grid md:grid-cols-12 md:gap-8 xl:gap-10 oxl1:gap-14 gap-2 flex md:justify-center items-center justify-between flex-wrap'>
                                <div className="md:col-span-4 omd-1:basis-[47%] omd-1:mb-2">
                                    <div className="flex justify-between">
                                    <label htmlFor="skill" className="block mb-2 md:text-base text-sm font-medium text-black-1">Skills <span className='text-red-1'>*</span></label>
                                    <p className={`text-sm omd-1:hidden text-red-1 font-medium italic ${values[13].error ? "visible":"invisible"}`}>Select atleast 1 skill.</p>
                                    <p className={`md:hidden text-xs text-red-1 font-normal italic ${values[13].error ? "visible":"invisible"}`}>Add skill</p>
                                    </div>
                                    <Autocomplete
                                   
                                    value={values[13].skill}
                                    onChange={(event, newValue) => {
                                        if (typeof newValue === 'string') {
                                            var newstate = [...values];
                                            newstate[13].skill = newValue;
                                            newstate[13].error = false;
                                            setValues(newstate);
                                        } else if (newValue && newValue.inputValue) {
                                        // Create a new value from the user input
                                            var newstate = [...values];
                                            newstate[13].skill = newValue?.inputValue;
                                            newstate[13].error = false;
                                            setValues(newstate);
                                        } else {
                                            var newstate = [...values];
                                            newstate[13].skill = newValue?.value || '';
                                            newstate[13].error = false;
                                            setValues(newstate);
                                        }
                                    }}
                                    filterOptions={(options, params) => {
                                        const filtered = filter(options, params);
                                
                                        const { inputValue } = params;
                                        // Suggest the creation of a new value
                                        const isExisting = options.some((option) => inputValue === option.value);
                                        if (inputValue !== '' && !isExisting) {
                                        filtered.push({
                                            inputValue,
                                            value: `Add "${inputValue}"`,
                                        });
                                        }
                                
                                        return filtered;
                                    }}
                                    selectOnFocus
                                    clearOnBlur
                                    handleHomeEndKeys
                                    id="skill"
                                    options={displaySkillsOptions}
                                    getOptionLabel={(option) => {
                                        // Value selected with enter, right from the input
                                        if (typeof option === 'string') {
                                        return option;
                                        }
                                        // Add "xxx" option created dynamically
                                        if (option.inputValue) {
                                        return option.inputValue;
                                        }
                                        // Regular option
                                        return option.value;
                                    }}
                                    renderOption={(props, option) => <li {...props}>{option.value}</li>}
                                    sx={{ width: 2/2 }}
                                    freeSolo
                                    includeInputInList
                                    renderInput={(params) => (
                                        <TextField {...params}  error={values[13].error} placeholder={miniScreen ? 'Skills' : 'Select skills' } />
                                    )}
                                    />
                                </div>
                                <div className="md:col-span-3 omd-1:basis-[47%] omd-1:mb-2">
                                    <div className="flex justify-between items-center mb-2.5">
                                    <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic w-full text-right ${values[14].error ? "visible":"invisible"}`}>Select years.</p>
                                    </div>
                                    <Select
                                    error={values[14].error}
                                    value={values[14].skillExp}
                                    onChange={handleChange(14,'skillExp')}
                                    displayEmpty
                                    renderValue={
                                     values[14].skillExp !== "" ? undefined : () => <Placeholder>Exp</Placeholder>
                                        }
                                    sx={{ width: 2/2 }}
                                    > 
                                        <MenuItem>Select experience</MenuItem>
                                        {
                                        [...Array(21)].map((x, i) =>(
                                            <MenuItem key={i} value={i+1}>{i+1}</MenuItem>
                                        ))
                                        }
                                    </Select>
                                </div>
                                <div className="md:col-span-5 omd-1:basis-full">
                                    <div className="flex justify-between items-center omd-1:hidden">
                                    <label className="block mb-2 md:text-base text-sm font-medium text-black-1">Level - <span className={`${skillLevelValue !== null && (
                                        color[SkillLevelhover !== -1 ? SkillLevelhover : skillLevelValue]
                                    )}`} id="skillLevel">{skillLevelValue !== null && (
                                        labels[SkillLevelhover !== -1 ? SkillLevelhover : skillLevelValue]
                                    )}</span></label>
                                    </div>
                                    <div className="flex gap-1 justify-between omd-1:h-[35px] h-12 w-full">
                                        <div className='cursor-pointer rounded-lg'>
                                            <StyledRating
                                                name="hover-feedback"
                                                value={skillLevelValue}
                                                size='large'
                                                getLabelText={getLabelText}
                                                onChange={(event, newValue) => {
                                                    setSkillLevelValue(newValue);
                                                }}
                                                onChangeActive={(event, newHover) => {
                                                    setSkillLevelHover(newHover);
                                                }}
                                                max={5}
                                                icon={<div className={`flex-1 w-10 omd-1:w-6 omd-1:h-[35px] h-12 rounded-sm`}></div>}
                                                emptyIcon={<div className='flex-1 ml-0.5 w-10 omd-1:w-6 omd-1:h-[35px] h-12 rounded-sm bg-[#D9D9D9]'></div>}
                                            />
                                        </div>
                                        <div className="md:hidden flex justify-between items-center">
                                        <label className="block md:text-base text-sm font-medium text-black-1">Level-<span className={`${skillLevelValue !== null && (
                                        color[SkillLevelhover !== -1 ? SkillLevelhover : skillLevelValue]
                                        )}`} id="skillLevel">{skillLevelValue !== null && (
                                            labels[SkillLevelhover !== -1 ? SkillLevelhover : skillLevelValue]
                                        )}</span></label>
                                        </div>
                                        <div className="flex justify-end omd-1:float-right md:justify-start items-center hover:cursor-pointer" onClick={handleSkillAdd}>
                                            <img src='/addSkill.svg' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        {skillWithExpList.length > 0 && <div className='flex justify-start flex-wrap gap-6 mt-6'>
                            {skillWithExpList.map((skillObject, i) => (
                                <div key={i} className={`bg-[#F1F2F5] py-3 px-5 relative cursor-pointer rounded-[2px] ${values[13].skill ? skillObject.skill === values[13].skill && 'border border-blue-1' : skillWithExpList.length-1 === i && 'border border-blue-1'}`} onClick={() => editSkill(skillObject)}>
                                    <div className='absolute top-1 left-1'>
                                        <img src={`${skillObject.level <= 2 ? './redSkillTag.svg' : skillObject.level <= 4 ? 'yellowSkillTag.svg' : 'greenSkillTag.svg'}`} alt="" />
                                    </div>
                                    <div className=''>{skillObject.skill}</div>
                                    <div className='mt-2'>{skillObject.year} years</div>
                                    <div className='bg-[#6B6C7E] w-5 h-5 text-white-1 rounded-full flex justify-center items-center absolute top-0 -right-3 text-xs cursor-pointer' onClick={() => removeSkill(skillObject.skill)}><span>x</span> </div>
                                </div>
                            ))}
                        </div>}
                    </div>
                    {/* Job Title */}
                    <div className="mt-6">
                        <div className="flex justify-between">
                        <label htmlFor="jobTitle" className="block mb-2 md:text-base text-sm font-medium text-black-1">Job title <span className='text-red-1'>*</span></label>
                        <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[15].error ? "visible":"invisible"}`}>Add a job title.</p>
                        </div>
                        {/* <input type="text" id="gaperId" className="border-grey-7 font-medium border text-black-1 p-5 placeholder-grey-7 placeholder-font-normal text-sm rounded-sm  block w-full" placeholder="Enter current job title" /> */}
                        <TextField error={values[15].error} fullWidth value={values[15].currentJobTitle} onChange={handleChange(15,'currentJobTitle')} type="text" id="jobTitle" placeholder='Enter current job title' variant="outlined" />
                    </div>
                    {/* CV Link */}
                    <div className="mt-6">
                        <div className="flex justify-between">
                        <label htmlFor="file" className="block mb-2 md:text-base text-sm font-medium text-black-1">CV Link <span className='text-red-1'>*</span></label>
                        <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[16].error ? "visible":"invisible"}`}>Add a CV less than 1 mb</p>
                        </div>
                        <input type="file" value={CV.name} onChange={handleFileUpload} accept="application/pdf" />
                    </div>
                    {/* Next Button */}
                    <div className="mt-6">
                        <div className='grid grid-cols-12 items-center'>
                            <div className='col-span-4'>
                                <input type="button" onClick={handleNextClick} className='bg-blue-1 w-full h-auto text-white-1 rounded-sm p-4 text-center cursor-pointer' value="Next" />
                            </div>
                            <div className='col-span-8 ml-6'>
                                <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${error ? "visible":"invisible"}`}>Some of the fields are missing!</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${showAvatars ? 'block' : 'hidden'} w-auto h-auto bg-white-1 rounded-md md:pl-20 md:pr-20 md:pt-8 md:pb-10 p-5`}>
                    <div className='mb-6'>
                        <StyledTooltip title="Back">
                            <div className='flex justify-center items-center h-11 w-11 bg-blue-1 rounded-full p-3 cursor-pointer' onClick={() => setShowAvatars(false)}>
                                <img src="./backButton.svg" alt="" />
                            </div>
                        </StyledTooltip>
                    </div>
                    <div className="bg-blue-7 w-fit p-2 rounded md:hidden mb-2">
                        <span className='md:font-semibold text-blue-1'>Step 2 of 2</span>
                    </div>
                    <div className='flex justify-between items-center'>
                        <h1 className="md:text-2xl text-lg font-bold">Choose an Avatar</h1>
                        <div className="bg-blue-7 p-2 rounded omd-1:hidden">
                            <span className='md:font-semibold text-blue-1'>Step 2 of 2</span>
                        </div>
                    </div>
                    <div className='mt-6'>
                        <Avatars avatarsList={avatarsList} avatarSelected={avatarSelected} handleChooseAvatar={handleChooseAvatar} />
                    </div>
                    <div className="mt-6">
                        <div className='grid grid-cols-12 items-center'>
                            <div className='col-span-4 flex justify-center'>
                                <input type="submit" className='bg-blue-1 w-11/12 h-[45px] text-white-1 rounded-sm text-center cursor-pointer' value="Save" />
                            </div>
                            <div className='col-span-8 ml-6'>
                                <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${error ? "visible":"invisible"}`}>Please choose an Avatar!</p>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
  )
}

export default AddCandidates